// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: hsl(220deg 29% 90% / 50%); */
}

.loading-container {
  text-align: center;
}

.pl {
  width: 6em;
  height: 6em;
}

.pl__ring {
  animation: ringA 2s linear infinite;
}

.pl__ring--a {
  stroke: #f42f25;
}

.pl__ring--b {
  animation-name: ringB;
  stroke: #f49725;
}

.pl__ring--c {
  animation-name: ringC;
  stroke: #255ff4;
}

.pl__ring--d {
  animation-name: ringD;
  stroke: #f42582;
}

.loading-message {
  margin-top: 20px;
  font-size: 1.2rem;
  color: #333;
  font-weight: bold;
  text-transform: uppercase;
}

/* Animations */
@keyframes ringA {
  from, 4% {
    stroke-dasharray: 0 660;
    stroke-width: 20;
    stroke-dashoffset: -330;
  }
  12% {
    stroke-dasharray: 60 600;
    stroke-width: 30;
    stroke-dashoffset: -335;
  }
  32% {
    stroke-dasharray: 60 600;
    stroke-width: 30;
    stroke-dashoffset: -595;
  }
  40%, 54% {
    stroke-dasharray: 0 660;
    stroke-width: 20;
    stroke-dashoffset: -660;
  }
  62% {
    stroke-dasharray: 60 600;
    stroke-width: 30;
    stroke-dashoffset: -665;
  }
  82% {
    stroke-dasharray: 60 600;
    stroke-width: 30;
    stroke-dashoffset: -925;
  }
  90%, to {
    stroke-dasharray: 0 660;
    stroke-width: 20;
    stroke-dashoffset: -990;
  }
}

@keyframes ringB {
  from, 12% {
    stroke-dasharray: 0 220;
    stroke-width: 20;
    stroke-dashoffset: -110;
  }
  20% {
    stroke-dasharray: 20 200;
    stroke-width: 30;
    stroke-dashoffset: -115;
  }
  40% {
    stroke-dasharray: 20 200;
    stroke-width: 30;
    stroke-dashoffset: -195;
  }
  48%, 62% {
    stroke-dasharray: 0 220;
    stroke-width: 20;
    stroke-dashoffset: -220;
  }
  70% {
    stroke-dasharray: 20 200;
    stroke-width: 30;
    stroke-dashoffset: -225;
  }
  90% {
    stroke-dasharray: 20 200;
    stroke-width: 30;
    stroke-dashoffset: -305;
  }
  98%, to {
    stroke-dasharray: 0 220;
    stroke-width: 20;
    stroke-dashoffset: -330;
  }
}

@keyframes ringC {
  from {
    stroke-dasharray: 0 440;
    stroke-width: 20;
    stroke-dashoffset: 0;
  }
  8% {
    stroke-dasharray: 40 400;
    stroke-width: 30;
    stroke-dashoffset: -5;
  }
  28% {
    stroke-dasharray: 40 400;
    stroke-width: 30;
    stroke-dashoffset: -175;
  }
  36%, 58% {
    stroke-dasharray: 0 440;
    stroke-width: 20;
    stroke-dashoffset: -220;
  }
  66% {
    stroke-dasharray: 40 400;
    stroke-width: 30;
    stroke-dashoffset: -225;
  }
  86% {
    stroke-dasharray: 40 400;
    stroke-width: 30;
    stroke-dashoffset: -395;
  }
  94%, to {
    stroke-dasharray: 0 440;
    stroke-width: 20;
    stroke-dashoffset: -440;
  }
}

@keyframes ringD {
  from, 8% {
    stroke-dasharray: 0 440;
    stroke-width: 20;
    stroke-dashoffset: 0;
  }
  16% {
    stroke-dasharray: 40 400;
    stroke-width: 30;
    stroke-dashoffset: -5;
  }
  36% {
    stroke-dasharray: 40 400;
    stroke-width: 30;
    stroke-dashoffset: -175;
  }
  44%, 50% {
    stroke-dasharray: 0 440;
    stroke-width: 20;
    stroke-dashoffset: -220;
  }
  58% {
    stroke-dasharray: 40 400;
    stroke-width: 30;
    stroke-dashoffset: -225;
  }
  78% {
    stroke-dasharray: 40 400;
    stroke-width: 30;
    stroke-dashoffset: -395;
  }
  86%, to {
    stroke-dasharray: 0 440;
    stroke-width: 20;
    stroke-dashoffset: -440;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Loading.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;EACzB;AACF","sourcesContent":[".loading {\n  height: 100vh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* background: hsl(220deg 29% 90% / 50%); */\n}\n\n.loading-container {\n  text-align: center;\n}\n\n.pl {\n  width: 6em;\n  height: 6em;\n}\n\n.pl__ring {\n  animation: ringA 2s linear infinite;\n}\n\n.pl__ring--a {\n  stroke: #f42f25;\n}\n\n.pl__ring--b {\n  animation-name: ringB;\n  stroke: #f49725;\n}\n\n.pl__ring--c {\n  animation-name: ringC;\n  stroke: #255ff4;\n}\n\n.pl__ring--d {\n  animation-name: ringD;\n  stroke: #f42582;\n}\n\n.loading-message {\n  margin-top: 20px;\n  font-size: 1.2rem;\n  color: #333;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n/* Animations */\n@keyframes ringA {\n  from, 4% {\n    stroke-dasharray: 0 660;\n    stroke-width: 20;\n    stroke-dashoffset: -330;\n  }\n  12% {\n    stroke-dasharray: 60 600;\n    stroke-width: 30;\n    stroke-dashoffset: -335;\n  }\n  32% {\n    stroke-dasharray: 60 600;\n    stroke-width: 30;\n    stroke-dashoffset: -595;\n  }\n  40%, 54% {\n    stroke-dasharray: 0 660;\n    stroke-width: 20;\n    stroke-dashoffset: -660;\n  }\n  62% {\n    stroke-dasharray: 60 600;\n    stroke-width: 30;\n    stroke-dashoffset: -665;\n  }\n  82% {\n    stroke-dasharray: 60 600;\n    stroke-width: 30;\n    stroke-dashoffset: -925;\n  }\n  90%, to {\n    stroke-dasharray: 0 660;\n    stroke-width: 20;\n    stroke-dashoffset: -990;\n  }\n}\n\n@keyframes ringB {\n  from, 12% {\n    stroke-dasharray: 0 220;\n    stroke-width: 20;\n    stroke-dashoffset: -110;\n  }\n  20% {\n    stroke-dasharray: 20 200;\n    stroke-width: 30;\n    stroke-dashoffset: -115;\n  }\n  40% {\n    stroke-dasharray: 20 200;\n    stroke-width: 30;\n    stroke-dashoffset: -195;\n  }\n  48%, 62% {\n    stroke-dasharray: 0 220;\n    stroke-width: 20;\n    stroke-dashoffset: -220;\n  }\n  70% {\n    stroke-dasharray: 20 200;\n    stroke-width: 30;\n    stroke-dashoffset: -225;\n  }\n  90% {\n    stroke-dasharray: 20 200;\n    stroke-width: 30;\n    stroke-dashoffset: -305;\n  }\n  98%, to {\n    stroke-dasharray: 0 220;\n    stroke-width: 20;\n    stroke-dashoffset: -330;\n  }\n}\n\n@keyframes ringC {\n  from {\n    stroke-dasharray: 0 440;\n    stroke-width: 20;\n    stroke-dashoffset: 0;\n  }\n  8% {\n    stroke-dasharray: 40 400;\n    stroke-width: 30;\n    stroke-dashoffset: -5;\n  }\n  28% {\n    stroke-dasharray: 40 400;\n    stroke-width: 30;\n    stroke-dashoffset: -175;\n  }\n  36%, 58% {\n    stroke-dasharray: 0 440;\n    stroke-width: 20;\n    stroke-dashoffset: -220;\n  }\n  66% {\n    stroke-dasharray: 40 400;\n    stroke-width: 30;\n    stroke-dashoffset: -225;\n  }\n  86% {\n    stroke-dasharray: 40 400;\n    stroke-width: 30;\n    stroke-dashoffset: -395;\n  }\n  94%, to {\n    stroke-dasharray: 0 440;\n    stroke-width: 20;\n    stroke-dashoffset: -440;\n  }\n}\n\n@keyframes ringD {\n  from, 8% {\n    stroke-dasharray: 0 440;\n    stroke-width: 20;\n    stroke-dashoffset: 0;\n  }\n  16% {\n    stroke-dasharray: 40 400;\n    stroke-width: 30;\n    stroke-dashoffset: -5;\n  }\n  36% {\n    stroke-dasharray: 40 400;\n    stroke-width: 30;\n    stroke-dashoffset: -175;\n  }\n  44%, 50% {\n    stroke-dasharray: 0 440;\n    stroke-width: 20;\n    stroke-dashoffset: -220;\n  }\n  58% {\n    stroke-dasharray: 40 400;\n    stroke-width: 30;\n    stroke-dashoffset: -225;\n  }\n  78% {\n    stroke-dasharray: 40 400;\n    stroke-width: 30;\n    stroke-dashoffset: -395;\n  }\n  86%, to {\n    stroke-dasharray: 0 440;\n    stroke-width: 20;\n    stroke-dashoffset: -440;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
